import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import * as TableActions from './store/actions/company-site-user-location.actions';
import { Observable } from 'rxjs';
import { selectCompanyId, selectUser , selectSiteId , selectCompanyIdSiteId, selectCompanySiteCategoryProductGroupProductState} from './store/reducers';

@Injectable({
  providedIn: 'root'
})
export class CompanySiteToStoreService {

  constructor(
    private store: Store<any>,
  ) { }

  addCompanySiteUserLocation(companyId: any, siteId: any): void {
    this.store.dispatch(new TableActions.AddCompanySiteUserLocation(companyId, siteId));
  }

  addCompanyUserLocation(companyId: any): void {
    this.store.dispatch(new TableActions.AddCompanyUserLocation(companyId));
  }

  addSiteUserLocation(siteId: any): void {
    this.store.dispatch(new TableActions.AddSiteUserLocation(siteId));
  }

  addCompanySiteCategoryProductGroupProduct(companyId: any, siteId: any, categoryId: any, productGroupId?: any, productId?: any): void {
    this.store.dispatch(new TableActions.AddCompanySiteCategoryProductGroupProduct(companyId, siteId, categoryId, productGroupId, productId));
  }


  addSiteUser(user: any): void {
    this.store.dispatch(new TableActions.AddSiteUser(user));
  }

  addSiteUserHotelRoomNumber(roomNumber: any): void {
    this.store.dispatch(new TableActions.AddSiteUserHotelRoomNumber(roomNumber));
  }

   getCompanyIdUserLocation(): any {
    return this.store.pipe(select(selectCompanyId));
  }

  getSiteIdUserLocation(): any {
    return this.store.pipe(select(selectSiteId));
  }

  getCompanySiteIdUserLocation(): any {
    return this.store.pipe(select(selectCompanyIdSiteId));
  }

  getCompanySiteCategoryProductGroupProduct(): any {
    return this.store.pipe(select(selectCompanySiteCategoryProductGroupProductState));
  }


  getUser(): any {
    return this.store.pipe(select(selectUser));
  }

  // getRoomNumber(): any {
  //   return this.store.pipe(select(selectRoomNumber));
  // }


}
